var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityHigh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6805 11.9491L10.0989 2.13165C9.64021 1.37064 8.84737 0.910156 7.99577 0.910156C7.14416 0.910156 6.35132 1.37064 5.89265 2.13165L0.311032 11.9491C-0.0902728 12.6586 -0.104144 13.5413 0.274646 14.2646C0.712715 15.079 1.53013 15.5803 2.41415 15.5767H13.5774C14.4554 15.5866 15.2714 15.098 15.7169 14.2955C16.107 13.5643 16.0931 12.6663 15.6805 11.9491ZM7.99577 12.4894C7.59386 12.4894 7.26804 12.1439 7.26804 11.7176C7.26804 11.2913 7.59386 10.9458 7.99577 10.9458C8.39767 10.9458 8.72349 11.2913 8.72349 11.7176C8.72349 12.1439 8.39767 12.4894 7.99577 12.4894ZM7.99577 10.174C8.39767 10.174 8.72349 9.82841 8.72349 9.40215V6.31489C8.72349 5.88863 8.39767 5.54307 7.99577 5.54307C7.59386 5.54307 7.26804 5.88863 7.26804 6.31489V9.40215C7.26804 9.82841 7.59386 10.174 7.99577 10.174Z",
    fill: "#F00707"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityHigh);
export default __webpack_public_path__ + "static/media/severity_high.5fe08eb71b736658f6e5e980fb93c6ed.svg";
export { ForwardRef as ReactComponent };